import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {useTranslation} from "react-i18next";
import { motion } from "framer-motion";
import type { ReactNode } from "react";

interface ConfirmModalProps {
  title: ReactNode;
  message: ReactNode;
  confirm?: ReactNode;
  cancel?: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
}

function ConfirmModal(props: ConfirmModalProps) {
  const { t } = useTranslation();
  return (
    <motion.div
      className="modal show"
      style={{ display: 'block' }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.15 }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: -10 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: -10 }}
        transition={{ duration: 0.2, ease: "easeOut" }}
      >
        <Modal.Dialog>
          <Modal.Header>
            <Modal.Title>{props.title}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>{props.message}</p>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={props.onCancel}>{props.cancel ? props.cancel : t("cancel")}</Button>
            <Button variant="primary" onClick={props.onConfirm}>{props.confirm ? props.confirm : t("confirm")}</Button>
          </Modal.Footer>
        </Modal.Dialog>
      </motion.div>
    </motion.div>
  );
}

export default ConfirmModal;
